import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-accordian',
  templateUrl: './accordian.component.html',
})
export class AccordianComponent {

  @Input() header: string = "";
  @Input() multiple: boolean = true;

}
